"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID = void 0;
var UUID = /** @class */ (function () {
    function UUID() {
    }
    //timestamp
    UUID.uuidV1 = function () {
        return "".concat(Date.now(), "-").concat(Math.random());
    };
    return UUID;
}());
exports.UUID = UUID;
//# sourceMappingURL=uuid.js.map